export default "__VITE_ASSET__DTskXARJ__"